import axios from 'axios';
import '../config.js';

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

const base = (path) => `${global.config.url}/admin/catalog${path}`;

const sortBy = (items, field) => (Array.isArray(items) ? [...items] : [])
  .sort((left, right) => String(left && left[field] || '').localeCompare(String(right && right[field] || '')));

const adminCatalogApi = {
  getAppProviders: async () => sortBy((await axios.get(base('/appproviders'), authConfig())).data, 'appName'),
  getAppProvider: async (id) => (await axios.get(base(`/appproviders/${id}`), authConfig())).data,
  createAppProvider: async (request) => (await axios.post(base('/appproviders'), request, authConfig())).data,
  updateAppProvider: async (id, request) => (await axios.put(base(`/appproviders/${id}`), request, authConfig())).data,
  getLmsTypes: async () => sortBy((await axios.get(base('/lmstypes'), authConfig())).data, 'name'),
  getLmsType: async (id) => (await axios.get(base(`/lmstypes/${id}`), authConfig())).data,
  createLmsType: async (request) => (await axios.post(base('/lmstypes'), request, authConfig())).data,
  updateLmsType: async (id, request) => (await axios.put(base(`/lmstypes/${id}`), request, authConfig())).data,
};

export default adminCatalogApi;